export default __webpack_public_path__ + "static/char-s-01-kr-72b18d2caa365a209d25690e1cf6aa5d.png";